<template>
  <div :id="this.id" @contextmenu.prevent="handler($event)"
       class="sitebuilder-element-container"
       element="CounterTextComponent"
       :data-hide-desktop="!this.internal_config.showDesktop"
       :data-hide-mobile="!this.internal_config.showMobile"
       :config-properties="JSON.stringify(internal_config)" :style="style()" v-on:click="focusElement($event)">

    <vue-draggable-resizable v-bind:w="parseInt(internal_config.width)" v-bind:h="parseInt(internal_config.height)"
                             @resizing="onResize" :draggable="false" ref="draggableResizable">

      <sync-drag :target="this"/>

      <rotate :target="this.$refs.draggableResizable" :config="this.internal_config"/>

      <options-element-bar ref="optionsBar" :elem="this" name='ct-component-CounterTextComponent'></options-element-bar>

      <div class="text-area"
           v-bind:style="{height : height,width : width,border : border,'border-radius': radius,background: background,'box-shadow': boxShadow,}">
        <a :style="textStyle()" ref="obj">{{ internal_config.init }}</a>
      </div>

      <resources ref="resourcesData"></resources>
    </vue-draggable-resizable>
  </div>
</template>

<script>

  import Data from './Model';
  import Resources from './Resources.vue';
  import OptionsElementBar from "../OptionsElementBar";
  import MixinComponents from "../../../../js/mixins/MixinComponents";

  export default {
    name: 'CounterTextComponent',
    props: ['config', 'id', 'preview'],
    mixins: [MixinComponents],
    components: {
      OptionsElementBar,
      Resources,
    },
    watch: {
      'internal_config': {
        deep: true,
        handler(value) {
          this.$eventHub.setValueElementConfig(this.id, value);
          this.$eventPointer.log(this.id, value);
        }
      },
    },

    computed: {

      background() {
        let bg = this.internal_config.backgroundColor;

        if (this.internal_config.backgroundImage !== 'none' && typeof this.internal_config.backgroundImage !== 'undefined') {
          bg += ' url("' + this.internal_config.backgroundImage + '")';
          bg += ' ' + this.internal_config.backgroundPosition;
          bg += ' / ' + this.internal_config.backgroundSize;
          bg += ' ' + this.internal_config.backgroundRepeat;
          bg += ' ' + this.internal_config.backgroundOrigin;
        }

        return bg;
      }
    },
    data() {
      return Data.data();
    },
    methods: {

      onResize: function (x, y, width, height) {
        this.internal_config.width = width + 'px';
        this.internal_config.height = height + 'px';

        this.$refs.resourcesData.setValuesData(this);
      },

      showResources() {
        return this.$refs.resourcesData.getValuesData();
      },

      build(config) {
        this.internal_config = config;
      },

      rebuild() {
        let vm = this;
        let config = this.internal_config;
        this.internal_config = {};
        this.$nextTick(() => {
          vm.internal_config = config;
        });
      },

      textStyle() {
        return ` width: ${this.internal_config.width};
                     height : ${this.internal_config.height};
                     font-family: ${this.internal_config.textStyle.family};
                     font-size: ${this.internal_config.textStyle.size};
                     text-align: ${this.internal_config.textStyle.align};
                     font-weight: ${this.internal_config.textStyle.weight};
                     font-style: ${this.internal_config.textStyle.style};
                     text-decoration: ${this.internal_config.textStyle.stroke};
                     color: ${this.internal_config.textStyle.color}`;
      },

      style() {

        return `left:  ${this.internal_config.left};
                    padding-top: ${this.internal_config.paddingTop};
                    padding-left: ${this.internal_config.paddingLeft};
                    z-index: ${this.internal_config.zIndex};max-width: ${this.internal_config.maxWidth};margin: 0 auto;
                    padding-right: ${this.internal_config.paddingRight};
                    padding-bottom: ${this.internal_config.paddingBottom};
                    top: ${this.internal_config.top}`;
      },

      styleResize() {
        return `{width: ${this.internal_config.width}, height:  ${this.internal_config.height}}`;
      },

      animateValue(obj, start, end, duration) {
        var range = end - start;
        var current = start;
        var increment = end > start ? 1 : -1;
        var stepTime = Math.abs(Math.floor(duration / range));
        var timer = setInterval(function () {
          current += increment;
          obj.innerHTML = current;
          if (current == end) {
            clearInterval(timer);
          }
        }, stepTime);
      }
    },

    created() {
      this.build(this.$props.config);

      this.internal_config = window.mergeRecursive(this.props, this.$props.config);
    },

    mounted() {
      if (this.$props.preview) {
        this.$root.$emit('applyAnimation', this, 'sitebuilder-element-container');

        this.$el.classList.add('preview');

        let vm = this;

        this.$el.addEventListener('mouseover', function () {
          document.body.style.setProperty('--button-background-color--hover', vm.internal_config.backgroundColorHover);
          document.body.style.setProperty('--button-text-color--hover', vm.internal_config.textColorHover);
        });
      }

      this.animateValue(this.$refs.obj, parseFloat(this.internal_config.init), parseFloat(this.internal_config.finish), parseInt(this.internal_config.timer));

      let objIds = [];
      $('[id]').each(function () {
        var ids = $('[id="' + this.id + '"]');
        if (ids.length > 1 && ids[0] == this && parseInt(this.id))
          objIds.push(this.id);
      });
      if (objIds.includes(this.id)) {
        this.id = Date.now() + parseInt(Math.random() * 10000);
      }

      this.$root.$on('setConfigElement', (id, obj) => {
        if (this.id == id) {
          this.config = obj;
          this.internal_config = obj;
        }
      });
      this.$refs.resourcesData.setValuesData(this);
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

@media (max-width: 800px) {
  .text-area {
    width: auto !important;

    a {
      width: 300px !important;
    }
  }
}

[data-device="mobile"] .text-area {
  width: auto !important;

  a {
    width: 300px !important;
  }
}

[data-device="tablet"] .text-area {
  width: auto !important;

  a {
    width: 768px !important;
  }
}

.text-area a {
  text-align: center;
  display: table-cell;
  vertical-align: middle;
}

.preview .text-area:hover {
  cursor: pointer;
  background-color: var(--button-background-color--hover) !important;
  color: var(--button-text-color--hover) !important;
}

</style>



// WEBPACK FOOTER //
// src/components/editor/apps/CounterText/CounterText.vue